<template lang="pug">
#modal-visualizacao-laudo
    el-dialog(
        title='Informar resultado do laudo',
        width='500px',
        top='5vh',
        :visible='show',
        @close='closeDialog()'
    )
        p.mb-1 Identificador: {{ laudo.identificador }}
        p.mb-1 Beneficiário: {{ laudo.beneficiario ? laudo.beneficiario : '--' }}

        hr

        h4.font-weight-bold Resultado de análise
        .d-flex.flex-column.py-3
            el-radio(v-model='radio', label='conforme') Conforme
            el-radio(v-model='radio', label='inconforme') Inconforme

        h4.font-weight-bold.py-3 Upload de resultado
        el-upload.upload-demo(
            action='#',
            drag,
            :file-list='fileList',
            :limit='1',
            :on-exceed='handleExceed',
            :auto-upload='false',
            accept='.pdf',
            :on-change='onLoadFile',
            :on-remove='onRemoveFile',
            ref='upload'
        )
            i.el-icon-upload
            .el-upload__text.w-100 Arraste o arquivo PDF aqui ou <em>clique para subir</em>

        .d-flex.flex-direction.justify-content-between.py-3
            el-button(slot='footer', size='mini', @click='closeDialog') Voltar
            el-button(
                slot='footer',
                size='mini',
                type='primary',
                :loading='loading',
                @click='inserirResultado'
            ) Finalizar
</template>

<script>
import OperacaoLaudoService from '@/services/OperacaoLaudoService';

export default {
    name: 'ModalInsercaoResultados',

    emits: ['atualizarListagem'],

    props: {
        laudo: {
            type: Object,
            required: true
        },
        show: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            radio: null,
            arquivoComResultado: null,
            fileList: [],
            loading: false
        };
    },

    methods: {
        closeDialog() {
            this.clearFields();
            this.$emit('update:show', false);
        },

        async inserirResultado() {
            if (!this.radio) {
                this.$notify.error({
                    message: 'Resultado da análise é obrigatório.'
                });
                return;
            }

            if (!this.arquivoComResultado) {
                this.$notify.error({
                    message: 'Arquivo com o resultado é obrigatório.'
                });
                return;
            }

            const input = {
                id: this.laudo.id,
                status: this.radio,
                arquivo: this.arquivoComResultado.raw
            };

            this.loading = true;

            await OperacaoLaudoService.inserirResultado(input)
                .then(response => {
                    if (response.status === 200) {
                        this.$notify.success({
                            message: 'Resultado adicionado com sucesso!'
                        });

                        this.closeDialog();
                        this.$emit('atualizarListagem');
                    }
                })
                .catch(() => {
                    this.$notify.error({
                        message: 'Ocorreu um erro ao adicionar resultado.'
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        onLoadFile(file) {
            this.arquivoComResultado = file;
        },

        onRemoveFile(file) {
            _.remove(this.fileList, o => {
                return o.uid === file.id;
            });
            this.arquivoComResultado = null;
        },

        handleExceed() {
            this.$notify.warning(`O limite é de 1 arquivo PDF!`);
        },

        clearFields() {
            this.radio = null;
            this.arquivoComResultado = null;
            this.fileList = [];
        }
    }
};
</script>

<style lang="scss">
#modal-visualizacao-laudo {
    .el-dialog__footer {
        margin-top: -30px;
        display: flex;
        justify-content: flex-start;
    }

    .el-upload,
    .el-upload--text,
    .el-upload-dragger {
        width: 100%;
    }
}
</style>
